import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-forestDeep text-mutedDark" data-id="element-88" data-mp="3gf96t1ka0gbl">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-89" data-mp="3ggtx2ezk5d3n" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-90" data-mp="32oni2w855c5s">
        <p className="font-display text-lg font-extrabold uppercase text-white" data-id="element-91" data-mp="32m1et8sa9itd">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-92" data-mp="36n3axgqwler4">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-forestSoft pt-6 text-xs" data-id="element-93" data-mp="3ud7gvurkdqla">
          © 2026 {productName} — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}